<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="risk-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="6"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <g class="scale">
      <!-- Outer rings -->
      <circle
        cx="100"
        cy="75"
        r="40"
        fill="none"
        stroke="#ede9fe"
        stroke-width="1"
      />
      <circle
        cx="100"
        cy="75"
        r="28"
        fill="none"
        stroke="#e9d5ff"
        stroke-width="1"
      />
      <circle
        cx="100"
        cy="75"
        r="16"
        fill="#f5f3ff"
        stroke="#c4b5fd"
        stroke-width="1"
      />

      <!-- Pentagon data shape -->
      <polygon
        points="100,45 130,65 120,100 80,100 70,65"
        fill="rgba(167, 139, 250, 0.15)"
        stroke="#a78bfa"
        stroke-width="1.5"
      />

      <!-- Center -->
      <g filter="url(#risk-glow)">
        <circle cx="100" cy="75" r="6" fill="#7c3aed" />
      </g>

      <!-- Vertex dots -->
      <circle cx="100" cy="45" r="4" fill="#7c3aed" class="pulse" />
      <circle cx="130" cy="65" r="4" fill="#7c3aed" class="pulse delay1" />
      <circle cx="120" cy="100" r="4" fill="#a78bfa" class="pulse delay2" />
      <circle cx="80" cy="100" r="4" fill="#a78bfa" class="pulse delay3" />
      <circle cx="70" cy="65" r="4" fill="#7c3aed" class="pulse delay4" />
    </g>
  </svg>
</template>

<style scoped>
@keyframes pulse {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
.pulse {
  animation: pulse 3s ease-in-out infinite;
}
.scale {
  animation: scale 4s ease-in-out infinite;
  transform-origin: 100px 75px;
}
.delay1 {
  animation-delay: 0.3s;
}
.delay2 {
  animation-delay: 0.6s;
}
.delay3 {
  animation-delay: 0.9s;
}
.delay4 {
  animation-delay: 1.2s;
}
</style>
